module.exports = __webpack_public_path__ + "static/media/sprintbot1.abb7af49.png";